import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export enum ShopperAiSettingsOptimizationType {
  BUNDLES_OPTIMIZATION = "bundles_optimization",
  DISCOUNTS_OPTIMIZATION = "discounts_optimization",
  ORDER_EDITING_SKILLS_OPTIMIZATION = "order_editing_skills_optimization",
}

export const ShopperAiSettingsOptimizationConfigSchema = z.object({
  dismissals: z.number(),
  lastDismissal: z.date().nullish(),
  completed: z.date().nullish(),
});

export const ShopperAiSettingsOptimizationSchema = z.object({
  _id: zExt.objectId(),
  userId: zExt.objectId(),
  type: createEnum(ShopperAiSettingsOptimizationType),
  viewHistory: ShopperAiSettingsOptimizationConfigSchema,
  createdAt: z.date(),
  updatedAt: z.date(),
});

export const UpsertShopperAiSettingsOptimizationSchema = z.object({
  userId: zExt.objectId(),
  type: createEnum(ShopperAiSettingsOptimizationType),
  viewHistory: ShopperAiSettingsOptimizationConfigSchema,
});

export type ShopperAiSettingsOptimization = z.infer<
  typeof ShopperAiSettingsOptimizationSchema
>;
export type UpsertShopperAiSettingsOptimization = z.infer<
  typeof UpsertShopperAiSettingsOptimizationSchema
>;
export type ShopperAiSettingsOptimizationConfig = z.infer<
  typeof ShopperAiSettingsOptimizationConfigSchema
>;
